import React, {useState,useEffect} from 'react';
import classes from './CommercialProjects.css';
import Project from '../../Project/Project';
import Container from '../../../hoc/Container/Container';
import CardContainer from '../../../hoc/CardContainer/CardContainer';
import axios from '../../../firebase-axios';
const commercialProjects = () => {
    const [state,setState] = useState({projects:[]});
  let projectList = [];
  useEffect(() => {
    axios.get('commercialProjects.json')
    .then((res) => {
        const resList = [];
        for(const key in res.data) {
            resList.push({
                id:key,
                ...res.data[key]
            });
        }
        setState({projects:resList});
    })
    .catch((err) => {
        alert('Something went wrong');
        console.log(err);
    })
  },[]);

  if(state.projects.length != 0) {
    projectList = state.projects.map((data) => {
        return (<Project commercial key={data.id} name={data.name} github={data.github} online={data.online} pariority={data.pariority} posterImage={data.posterImage} technologies={data.technologies} description={data.description} />);
    });
  }

    return (<section id="commercialProjects" className={classes.projects + ' appMTop30'}  >
        <h2 className="site-section-title">Commercial Projects</h2>
    <Container>
        <CardContainer>
            {projectList}
        </CardContainer>
    </Container>
</section>);
}

export default commercialProjects;


// WEBPACK FOOTER //
// ./src/components/Sections/CommercialProjects/CommercialProjects.js